export const initialValuesAddCommentBills = {
	comment: "",
}